import commuRoutes from "./CommuRouter";
import ecpRoutes from "./EcpRoutes";
import mainRoutes from "./MainRoutes";
import cmmnRoutes from "@/router/items/common/cmmnRoutes";
import diagRoutes from "./DiagRoutes";
import employRoutes from "./EmployRoutes";
import portfolioRoutes from "./PortfolioRoutes";
import counselRouter from "./CounselRouter";
import mileageRoutes from "./MileageRoutes";
import mypageRoutes from "./MypageRoutes";
import careerRoutes from "./CareerRoutes";

/**
 * meta: {
 *   requiresAuth: true  // 로그인 필요
 *   noCaching: true     // 캐싱 방지
 *   isDynamic: true     // 동적 라우트 (메뉴 권한 체크)
 *   menuCd: string      // 메뉴 코드
 *   title: string       // 국문 타이틀
 *   - 모바일 헤더 관련
 *   mobileTitle: string // 모바일 헤더 타이틀
 *   mobileHd: true      // 모바일 헤더 별도 적용
 *   likeBtn: true       // 모바일 헤더에 찜하기 버튼 노출
 *   homeBtn: true       // 모바일 헤더에 홈 버튼 노출
 *   gnbBtn: true        // 모바일 헤더에 메뉴 버튼 노출
 *   site: 'inha'        // 인하대 페이지
 * }
 */

const studentRoutes = [
  {
    path: "",
    name: "index",
    redirect: { name: "student" },
  },
  {
    path: "/",
    name: "student",
    meta: {
      title: "학생 화면",
      noCaching: true,
    },
    redirect: { name: "studentMain" },
    component: () => import("@/layout/LayoutMain.vue"),
    children: [
      {
        path: "/login",
        meta: {
          title: "학생 로그인",
          mobileTitle: "학생 로그인",
          mobileHd: true,
        },
        component: () => import("@/views/common/login/CommonLogin.vue"),
      },
      {
        path: "/onlyDainIndex",
        meta: {
          title: "학생 로그인",
          mobileTitle: "학생 로그인",
          mobileHd: true,
          isDynamic: false,
        },
        component: () => import("@/views/common/login/OnlyDainIndex.vue"),
      },
      {
        path: "/signup",
        meta: {
          title: "회원가입",
          mobileTitle: "회원가입",
          isDynamic: false,
        },
        component: () => import("@/views/common/login/OtsdrSignup.vue"),
      },
      {
        path: "/portfolio/public/:encId(.*)",
        name: "student.portfolio.public",
        meta: {
          title: "포트폴리오",
          auth: false,
          noCrumb: true,
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/portfolio/main/PortfolioPreviewPublic.vue"),
      },

      ...mainRoutes, // 메인 라우트
      ...ecpRoutes, // 비교과 라우트
      ...commuRoutes,
      ...diagRoutes, // 역량진단 라우트
      ...employRoutes, // 취업정보 라우트
      ...counselRouter, // 상담
      ...portfolioRoutes,

      ...mileageRoutes, // 마일리지
      ...mypageRoutes, // 마이페이지
      ...careerRoutes, // 진로 라우트
    ],
  },
  {
    path: "/print-preview",
    meta: {
      auth: false,
      noCrumb: true,
    },
    component: () => import("@/components/base/PrintPreview.vue"),
  },
  ...cmmnRoutes, // 공통 라우트
];
export default studentRoutes;
